import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { Tabs, Row, Col, Button } from 'antd';
import { LoadingOverlay, EventList, FullHeightContainerLayout } from "components";
import { showError, showSuccess } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import _ from 'lodash';

const { TabPane } = Tabs;

class RoleAudit extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectRecordDetail: null
        }
    }

    componentWillMount() {
        this.props.getRoleEvents(this.props.role.roleId);
        this.setState({
            fetchingEvents: true
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetRoleEventsResultUpdate(prevProps);
    }

    onGetRoleEventsResultUpdate = (prevProps) => {
        if (this.props.getRoleEventsResult && this.props.getRoleEventsResult !== prevProps.getRoleEventsResult) {
            if (!this.props.getRoleEventsResult.success) {
                if (this.props.getRoleEventsResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get role events.");
                }
            }
            this.setState({
                fetchingEvents: false
            });
        }
    }

    render() {
        return (
            <FullHeightContainerLayout
                showHeader={false}
                showFooter={false}
                content={
                    this.state.fetchingEvents
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message="Getting role events...">
                        </LoadingOverlay>
                        :
                        <EventList eventList={this.props.roleEventsResult.Items}></EventList>
                }>
            </FullHeightContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getRoleEventsResult: state.roleAudit.getRoleEventsResult,
        roleEventsResult: state.roleAudit.roleEventsResult
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getRoleEvents: (roleId) => dispatch(actions.getRoleEventsRequest(roleId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoleAudit));